/* ArtMindr - Preview Flow backend connector. v5
   innerPage: klyuch za butona "Otvori knizhkata" (parvata stranica).
   true = bekendat ima /api/preview/inner (kachen 27.07).
   Bekendat vrashta 400 za ocvetyavane i plakat - zatova e samo za chetene. */
(function(){
  'use strict';
  var AMF = window.AMFConfig = {
    enabled: true,
    innerPage: true,
    previewUrl: 'https://preview.artmindr.com/api/preview',
    innerUrl:   'https://preview.artmindr.com/api/preview/inner',
    variants: {
      'coloring|fairy|soft':54357077000534,'coloring|fairy|hard':54357077033302,
      'coloring|princess|soft':54357150728534,'coloring|princess|hard':54357150761302,
      'coloring|ice_princess|soft':54357150859606,'coloring|ice_princess|hard':54357150892374,
      'coloring|ballet|soft':54357150925142,'coloring|ballet|hard':54357150957910,
      'coloring|superhero|soft':54357151678806,'coloring|superhero|hard':54357151711574,
      'coloring|dinosaurs|soft':54357151809878,'coloring|dinosaurs|hard':54357151842646,
      'coloring|football|soft':54357151875414,'coloring|football|hard':54357151908182,
      'coloring|lost_symbol|soft':54357152661846,'coloring|lost_symbol|hard':54357152694614,
      'coloring|astronaut|soft':54357152891222,'coloring|astronaut|hard':54357152923990,
      'coloring|doctor|soft':54357153055062,'coloring|doctor|hard':54357153087830,
      'coloring|mermaid|soft':54357153382742,'coloring|mermaid|hard':54357153415510,
      'coloring|knight|soft':54357153448278,'coloring|knight|hard':54357153481046,
      'poster|fairy|classic':54357078344022,'poster|fairy|premium':54357078376790,
      'poster|princess|classic':54357157183830,'poster|princess|premium':54357157216598,
      'poster|mermaid|classic':54357158068566,'poster|mermaid|premium':54357158101334,
      'poster|astronaut|classic':54357159018838,'poster|astronaut|premium':54357159051606,
      'poster|superhero|classic':54357159084374,'poster|superhero|premium':54357159117142,
      'poster|ice_princess|classic':54357159248214,'poster|ice_princess|premium':54357159280982,
      'poster|ballet|classic':54357160067414,'poster|ballet|premium':54357160100182,
      'poster|dinosaurs|classic':54357161673046,'poster|dinosaurs|premium':54357161705814,
      'poster|football|classic':54357161804118,'poster|football|premium':54357161836886,
      /* Четене: Книга 1 от всяка серия. Твърди = старите ID-та (непроменени),
         меки = новите варианти от 16.08 на €39.87.
         'single' остава като резерва за стари линкове/кеширан JS. */
      'reading|fairy|hard':54357165048150,      'reading|fairy|soft':54996062798166,
      'reading|princess|hard':54357165441366,   'reading|princess|soft':54996066566486,
      'reading|mermaid|hard':54357165539670,    'reading|mermaid|soft':54996068401494,
      'reading|astronaut|hard':54357165670742,  'reading|astronaut|soft':54996069646678,
      'reading|superhero|hard':54357165834582,  'reading|superhero|soft':54996072759638,
      'reading|vacation|hard':54357165867350,   'reading|vacation|soft':54996075086166,
      'reading|fairy|single':54357165048150,'reading|princess|single':54357165441366,'reading|mermaid|single':54357165539670,'reading|astronaut|single':54357165670742,'reading|superhero|single':54357165834582,'reading|vacation|single':54357165867350
    },
    masterBox: {
      fairy:     { soft:54357165998422, hard:54818341454166 },
      princess:  { soft:54357166031190, hard:54818341486934 },
      mermaid:   { soft:54369446822230, hard:54818341519702 },
      astronaut: { soft:54369446854998, hard:54818341552470 },
      superhero: { soft:54369446887766, hard:54818341585238 },
      vacation:  { soft:54369446920534, hard:54818341618006 },
      /* Първи учебен ден: кутията носи училищната книжка за четене, но оцветяването
         и плакатът са по друга тема — това е написано на картата в офертата. */
      school:    { soft:54996573421910, hard:54996573454678 }
    },
    /* Първи учебен ден: вариантите вървят по ПОЛ и по КОРИЦА, не по тема като другите.
       Ключът е '<пол>|<корица>'. Твърди €49.87 · меки €39.87. */
    schoolVariants: {
      'момче|hard':  54995870089558, 'момче|soft':  55001605144918,
      'момиче|hard': 54995870875990, 'момиче|soft': 55001605177686
    },
    masterBoxFallback: {
      ice_princess:'princess', ballet:'princess',
      dinosaurs:'superhero', football:'superhero', doctor:'superhero',
      knight:'superhero', lost_symbol:'superhero'
    },
    cartProps: function(state){
      var p = {
        'Име на детето': state.name,
        'Тема': state.themeLabel || state.theme,
        'Корица': state.coverLabel || '',
        'Снимка': state.photoUrl || '',
        'Преглед': state.previewUrl || '',
        '_preview_id': state.previewId || ''
      };
      if (state.offer === 'box') { p['Корица'] = state.mbHard ? 'Твърди (оцветяване)' : 'Меки (оцветяване)'; }
      if (state.gender) { p['Пол'] = state.gender; }
      // по избор — влизат само ако са попълнени, за да не цапат поръчката с празни редове
      if (state.backMsg && state.backMsg.trim())   { p['Послание на гърба'] = state.backMsg.trim(); }
      if (state.wishes  && state.wishes.trim())    { p['Допълнителни желания'] = state.wishes.trim(); }
      if (state.photoUrl2)                         { p['Втора снимка'] = state.photoUrl2; }
      if (state.consent)                           { p['Съгласие за снимката'] = 'Потвърдено'; }
      return p;
    }
  };
  var GENDER = { 'момиче':'girl', 'момче':'boy' };
  if(!AMF.enabled) return;

  function getCookie(n){
    try { var m = document.cookie.match(new RegExp('(^| )' + n + '=([^;]+)')); return m ? decodeURIComponent(m[2]) : null; }
    catch(e){ return null; }
  }
  function getFbc(){
    var existing = getCookie('_fbc');
    if (existing) return existing;
    try {
      var f = new URLSearchParams(window.location.search).get('fbclid');
      return f ? ('fb.1.' + Date.now() + '.' + f) : null;
    } catch(e){ return null; }
  }
  var _amfFired = {};
  function trackPreview(eventId, themeLabel){
    if (!eventId || _amfFired[eventId]) return;
    if (typeof fbq !== 'function') return;
    _amfFired[eventId] = true;
    try {
      fbq('trackCustom', 'PreviewGenerated', { content_name: themeLabel || '', content_category: 'preview' }, { eventID: eventId });
    } catch(e){ console.error('[amf] fbq error', e); }
  }
  function trackWhenVisible(eventId, themeLabel){
    if (!eventId) return;
    var tries = 0;
    (function find(){
      var img = document.querySelector('[data-amf-cover-front] img, [data-amf-stage] img');
      if (!img){
        if (tries++ < 40) return setTimeout(find, 150);
        return trackPreview(eventId, themeLabel);
      }
      if (img.complete && img.naturalWidth > 0) return trackPreview(eventId, themeLabel);
      img.addEventListener('load',  function(){ trackPreview(eventId, themeLabel); }, { once:true });
      img.addEventListener('error', function(){ trackPreview(eventId, themeLabel); }, { once:true });
    })();
  }

  function newPreviewId(){ return 'p' + Date.now().toString(36) + Math.random().toString(36).slice(2,8); }

  window.amfGenerate = function(state){
    if(!state.photoUrl){ console.error('[amf] no photoUrl'); window.amfPreviewReady(''); return; }
    state.previewId = newPreviewId();
    if(window.amfState){ window.amfState.previewId = state.previewId; }
    fetch(AMF.previewUrl, { method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({
        photo_url: state.photoUrl,
        child_name: state.name,
        gender: GENDER[state.gender] || 'girl',
        theme: state.theme || 'fairy',
        email: state.email,
        product: state.product || 'reading',
        fbp: getCookie('_fbp'),
        fbc: getFbc(),
        page_url: (window.location.origin + window.location.pathname)
      }) })
    .then(function(r){ return r.json(); })
    .then(function(d){
      var pu  = (d && d.preview_url) || '';
      var eid = (d && d.event_id) || '';
      var spi = (d && d.preview_id) || '';
      if(!spi && d){ console.warn('[amf] nyama preview_id. Poleta:', Object.keys(d)); }
      state.previewUrl = pu;
      state.serverPreviewId = spi;
      if(window.amfState){ window.amfState.previewUrl = pu; window.amfState.eventId = eid; window.amfState.serverPreviewId = spi; }
      window.amfPreviewReady(pu);
      if (pu) trackWhenVisible(eid || state.previewId, state.themeLabel || state.theme);
    })
    .catch(function(e){ console.error('[amf] generate error', e); window.amfPreviewReady(''); });
  };

  window.amfGenerateInner = function(state){
    if(!AMF.innerPage){ return Promise.reject(new Error('innerPage off')); }
    if(!state){ return Promise.reject(new Error('no state')); }
    if((state.product || 'reading') !== 'reading'){ return Promise.reject(new Error('samo za chetene')); }
    if(state.innerUrl){ return Promise.resolve({ inner_url: state.innerUrl, inner_text: state.innerText || '' }); }
    var pid = state.serverPreviewId;
    if(!pid){ return Promise.reject(new Error('lipsva preview_id')); }
    return fetch(AMF.innerUrl, { method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({
        preview_id: pid,
        child_name: state.name,
        gender: GENDER[state.gender] || 'girl',
        theme: state.theme || 'fairy',
        product: 'reading'
      }) })
      .then(function(r){
        if(!r.ok){ throw new Error('inner status ' + r.status); }
        return r.json();
      })
      .then(function(d){
        if(!d || !d.success || !d.inner_url){ throw new Error('inner bez inner_url'); }
        state.innerUrl = d.inner_url;
        state.innerText = d.inner_text || '';
        return d;
      });
  };

  function isPreviewItem(item){
    var p = item && item.properties;
    if(!p) return false;
    return !!(p._preview_id || p['Преглед']);
  }
  function clearPreviousPreviewItems(){
    return fetch('/cart.js', { headers:{'Accept':'application/json'} })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var items = (cart && cart.items) || [];
        var old = items.filter(isPreviewItem);
        if(!old.length) return;
        return old.reduce(function(chain, it){
          return chain.then(function(){
            return fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'},
              body: JSON.stringify({ id: it.key, quantity: 0 }) });
          });
        }, Promise.resolve());
      })
      .catch(function(){ });
  }
  function addToCart(variantId, state, qty){
    return fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ id: variantId, quantity: qty||1, properties: AMF.cartProps(state) }) })
      .then(function(r){ if(!r.ok){ return r.json().then(function(e){ throw new Error(e && e.description || 'cart'); }); } return r; });
  }

  function resolveVariant(state){
    if(state.theme === 'school' && state.offer !== 'box'){
      var cov = (state.cover === 'soft') ? 'soft' : 'hard';
      return AMF.schoolVariants[(state.gender || 'момиче') + '|' + cov] || null;
    }
    if(state.offer === 'box'){
      var slug = AMF.masterBoxFallback[state.theme] || state.theme;
      var row  = AMF.masterBox[slug];
      if(!row) return null;
      return state.mbHard ? row.hard : row.soft;
    }
    var key = state.product + '|' + state.theme + '|' + (state.cover || 'single');
    return AMF.variants[key] || null;
  }

  window.amfOnOrder = function(state){
    var vid = resolveVariant(state);
    if(!vid){ alert('Тази комбинация още не е налична. Пиши ни и ще ти помогнем.'); return; }
    if(!state.previewId){ state.previewId = newPreviewId(); }
    try { if(window.amfTrack){ window.amfTrack('checkout_started', { offer: state.offer === 'box' ? 'masterbox' : 'single', product: state.product, theme: state.theme }); } } catch(e){}
    clearPreviousPreviewItems()
      .then(function(){ return addToCart(vid, state); })
      .then(function(){ window.location.href = '/checkout'; })
      .catch(function(){ alert('Този вариант още не е наличен.'); });
  };

  window.amfOnUpsell = function(state){
    state.offer = 'box';
    window.amfOnOrder(state);
  };
})();